//20180830
(function(c) {
    c.fn.__bind__ = c.fn.bind;
    c.fn.__unbind__ = c.fn.unbind;
    c.fn.__find__ = c.fn.find;
    var d = {
        version: "0.7.9",
        override: /keypress|keydown|keyup/g,
        triggersMap: {},
        specialKeys: {
            27: "esc",
            9: "tab",
            32: "space",
            13: "return",
            8: "backspace",
            145: "scroll",
            20: "capslock",
            144: "numlock",
            19: "pause",
            45: "insert",
            36: "home",
            46: "del",
            35: "end",
            33: "pageup",
            34: "pagedown",
            37: "left",
            38: "up",
            39: "right",
            40: "down",
            109: "-",
            112: "f1",
            113: "f2",
            114: "f3",
            115: "f4",
            116: "f5",
            117: "f6",
            118: "f7",
            119: "f8",
            120: "f9",
            121: "f10",
            122: "f11",
            123: "f12",
            191: "/"
        },
        shiftNums: {
            "`": "~",
            "1": "!",
            "2": "@",
            "3": "#",
            "4": "$",
            "5": "%",
            "6": "^",
            "7": "&",
            "8": "*",
            "9": "(",
            "0": ")",
            "-": "_",
            "=": "+",
            ";": ":",
            "'": '"',
            ",": "<",
            ".": ">",
            "/": "?",
            "\\": "|"
        },
        newTrigger: function(b, g, a) {
            var h = {};
            h[b] = {};
            h[b][g] = {
                cb: a,
                disableInInput: false
            };
            return h
        }
    };
    d.specialKeys = c.extend(d.specialKeys, {
        96: "0",
        97: "1",
        98: "2",
        99: "3",
        100: "4",
        101: "5",
        102: "6",
        103: "7",
        104: "8",
        105: "9",
        106: "*",
        107: "+",
        109: "-",
        110: ".",
        111: "/"
    });
    c.fn.find = function(a) {
        this.query = a;
        return c.fn.__find__.apply(this, arguments)
    };
    c.fn.unbind = function(b, l, j) {
        if (c.isFunction(l)) {
            j = l;
            l = null
        }
        if (l && typeof l === "string") {
            var k = ((this.prevObject && this.prevObject.query) || this[0].id || this[0]).toString();
            var a = b.split(" ");
            for (var i = 0; i < a.length; i++) {
                delete d.triggersMap[k][a[i]][l]
            }
        }
        return this.__unbind__(b, j)
    };
    c.fn.bind = function(q, u, p) {
        var r = q.match(d.override);
        if (c.isFunction(u) || !r) {
            return this.__bind__(q, u, p)
        } else {
            var x = null,
                s = c.trim(q.replace(d.override, ""));
            if (s) {
                x = this.__bind__(s, u, p)
            }
            if (typeof u === "string") {
                u = {
                    combi: u
                }
            }
            if (u.combi) {
                for (var b = 0; b < r.length; b++) {
                    var w = r[b];
                    var t = u.combi.toLowerCase(),
                        v = d.newTrigger(w, t, p),
                        j = ((this.prevObject && this.prevObject.query) || this[0].id || this[0]).toString();
                    v[w][t].disableInInput = u.disableInInput;
                    if (!d.triggersMap[j]) {
                        d.triggersMap[j] = v
                    } else {
                        if (!d.triggersMap[j][w]) {
                            d.triggersMap[j][w] = v[w]
                        }
                    }
                    var a = d.triggersMap[j][w][t];
                    if (!a) {
                        d.triggersMap[j][w][t] = [v[w][t]]
                    } else {
                        if (a.constructor !== Array) {
                            d.triggersMap[j][w][t] = [a]
                        } else {
                            d.triggersMap[j][w][t][a.length] = v[w][t]
                        }
                    }
                    this.each(function() {
                        var e = c(this);
                        if (e.attr("hkId") && e.attr("hkId") !== j) {
                            j = e.attr("hkId") + ";" + j
                        }
                        e.attr("hkId", j)
                    });
                    x = this.__bind__(r.join(" "), u, d.handler)
                }
            }
            return x
        }
    };
    d.findElement = function(a) {
        if (!c(a).attr("hkId")) {
            if (c.browser.opera || c.browser.safari) {
                while (!c(a).attr("hkId") && a.parentNode) {
                    a = a.parentNode
                }
            }
        }
        return a
    };
    d.handler = function(G) {
        var C = d.findElement(G.currentTarget),
            B = c(C),
            a = B.attr("hkId");
        if (a) {
            a = a.split(";");
            var E = G.which,
                u = G.type,
                x = d.specialKeys[E],
                v = !x && String.fromCharCode(E).toLowerCase(),
                D = G.shiftKey,
                j = G.ctrlKey,
                A = G.altKey || G.originalEvent.altKey,
                F = null,
                b;
            for (b = 0; b < a.length; b++) {
                if (d.triggersMap[a[b]][u]) {
                    F = d.triggersMap[a[b]][u];
                    break
                }
            }
            if (F) {
                var z;
                if (!D && !j && !A) {
                    z = F[x] || (v && F[v])
                } else {
                    var t = "";
                    if (A) {
                        t += "alt+"
                    }
                    if (j) {
                        t += "ctrl+"
                    }
                    if (D) {
                        t += "shift+"
                    }
                    z = F[t + x];
                    if (!z) {
                        if (v) {
                            z = F[t + v] || F[t + d.shiftNums[v]] || (t === "shift+" && F[d.shiftNums[v]])
                        }
                    }
                }
                if (z) {
                    var y = false;
                    for (b = 0; b < z.length; b++) {
                        if (z[b].disableInInput) {
                            var w = c(G.target);
                            if (B.is("input") || B.is("textarea") || B.is("select") || w.is("input") || w.is("textarea") || w.is("select")) {
                                return true
                            }
                        }
                        y = y || z[b].cb.apply(this, [G])
                    }
                    return y
                }
            }
        }
    };
    window.hotkeys = d;
    return c
})(jQuery);
$.ajaxSetup({
    cache: false
});

function readDistCookie(d) {
    var f = d + "=";
    var b = document.cookie.split(";");
    for (var e = 0; e < b.length; e++) {
        var a = b[e];
        while (a.charAt(0) == " ") {
            a = a.substring(1, a.length)
        }
        if (a.indexOf(f) == 0) {
            return a.substring(f.length, a.length)
        }
    }
    return null
}

function fnExpand(f, e, d) {
    $("#" + f).hide();
    $("#" + e).show();
    $("#" + d).html("")
}

function fnClose() {
    $("#downloadMultiple").hide();
    $("#downloadMultiple1").hide();
    $("#downloadMultiple2").hide();
    $("#downloadMultiple3").hide()
}

function fnDialog(a) {
    if (a == "schematicsimulation") {
        var h = $("#schematicsimulation");
        var i = h.offset();
        $("#downloadMultiple").html($("#schematicdiv").html());
        var j = $("#downloadMultiple").height();
        var b = ($(window).scrollTop() + $(window).height());
        if (b < i.top + 60 + j) {
            $("#downloadMultiple").css("top", (i.top - 80 - j))
        } else {
            $("#downloadMultiple").css("top", (i.top + 40))
        }
        $("#downloadMultiple").show();
        $("#downloadMultiple").dialog("open")
    } else {
        if (a == "testsimulation") {
            var h = $("#testsimulation");
            var i = h.offset();
            $("#downloadMultiple1").html($("#testsimulationdiv").html());
            var j = $("#downloadMultiple1").height();
            var b = ($(window).scrollTop() + $(window).height());
            if (b < i.top + 60 + j) {
                $("#downloadMultiple1").css("top", (i.top - 80 - j))
            } else {
                $("#downloadMultiple1").css("top", (i.top + 40))
            }
            $("#downloadMultiple1").show();
            $("#downloadMultiple1").dialog("open")
        } else {
            if (a == "cadsimulation") {
                var h = $("#cadsimulation");
                var i = h.offset();
                $("#downloadMultiple2").html($("#caddiv").html());
                var j = $("#downloadMultiple2").height();
                var b = ($(window).scrollTop() + $(window).height());
                if (b < i.top + 60 + j) {
                    $("#downloadMultiple2").css("top", (i.top - 80 - j))
                } else {
                    $("#downloadMultiple2").css("top", (i.top + 40))
                }
                $("#downloadMultiple2").show();
                $("#downloadMultiple2").dialog("open")
            } else {
                if (a == "bom1") {
                    var h = $("#bom1");
                    var i = h.offset();
                    $("#downloadMultiple3").html($("#bomdiv").html());
                    var j = $("#downloadMultiple3").height();
                    var b = ($(window).scrollTop() + $(window).height());
                    if (b < i.top + 60 + j) {
                        $("#downloadMultiple3").css("top", (i.top - 80 - j))
                    } else {
                        $("#downloadMultiple3").css("top", (i.top + 40))
                    }
                    $("#downloadMultiple3").show();
                    $("#downloadMultiple3").dialog("open")
                }
            }
        }
    }
}
function replaceSplChars(content){
    var myRegExp=new RegExp("&#153;|&#174;|&#8482;","gi");
    content=content.replace(myRegExp,"");
    return content;
}
function popWin(theURL,winName,features) {
    var mywin = {};
    if(mywin == "undefined" || mywin == null) {
          mywin = window.open(theURL,winName,features);
    }else if(mywin.closed){
          mywin = window.open(theURL,winName,features);
    }
    mywin.location.href=theURL;
    mywin.focus();
 }

function setAcctNumber(acctNo,businessFamilyId){
    acctNo = "DM521018IOVV;";
    if(businessFamilyId == "44")
    {
        acctNo = "DM521018IOVV;";
    }
    if(businessFamilyId == "2")
    {
        acctNo = "DM521018IOVV;";
    }
    if(businessFamilyId == "1")
    {
        acctNo = "DM521018IOVV;";
    }
    return acctNo;
}

var myMap = {};
myMap['in_stock'] = "在庫中";
myMap['ships_in_24_to_48_hours'] = "24-48時間以内に発送";
myMap['ships_in_36_to_72_hours'] = "36-72 時間以内に発送";
myMap['out_of_stock'] = "在庫切れ";
myMap['available'] = "供給中";
myMap['available_for_backorder'] = "入荷待ち発注が可能です";
myMap['please_allow_48_business_hours_to_receive_activation_via_email.'] = "アクティベーション・コードを 2 営業日以内に E メールにてお知らせします。";

function fnTranslate(name,value,flag)
{
	var translatedText = '';
	if (flag == 2){
		values = value.replace('<font color=green><b>','');
		values = value.replace('<font color="green"><b>','');
		values = value.replace('<b><font color="green">','');
		values = values.replace('</b></font>','');
		values = values.replace('</b></FONT>','');
		values = values.replace('</font></b>','');
		values = values.replace('</FONT></b>','');
		values = values.toLowerCase();
		values = values.replace(/ /g,'_');
        values = values.replace('<font color=green><b>','');
		values = values.replace('<font_color=green><b>','');
		if (typeof myMap[values] !== 'undefined'){
			translatedText = '<font color=green><b>'+myMap[values]+'</b></font>';
		}else{
			translatedText = value;
		}
	}
	else{
		values = value.toLowerCase();
		values = values.replace(/ /g,'_');
		if (typeof myMap[values] !== 'undefined'){
			translatedText = myMap[values];
		}
		else{
			translatedText = value;
		}
	}
	return translatedText;
}
function ajaxCall(urlComp,divId)
{
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open('GET',urlComp, true);
    xhrRequest.timeout = 75000;
    xhrRequest.onload = function () {
        if (xhrRequest.status >= 200 && xhrRequest.status < 400) {
            // Success!
            sethtml(divId, xhrRequest.responseText);
            return xhrRequest.responseText;
        } else {
            console.error("HTTP status code: ", xhrRequest.status);
            return xhrRequest.responseText;

        }
    };
    xhrRequest.onerror = function () {
        console.error("HTTP status code: ", xhrRequest.status);
        return xhrRequest.responseText;
    };
    xhrRequest.ontimeout = function () {
        console.error("HTTP status code: ", xhrRequest.status);
        return xhrRequest.responseText;
    };
    function sethtml(div,content) 
    {
        var search = content;
        while(search.match(/(<script[^>]+javascript[^>]+>\s*(<!--)?)/i)) {
            search = search.substr(search.indexOf(RegExp.$1) + RegExp.$1.length);
            if (!(endscript = search.match(/((-->)?\s*<\/script>)/))) break;
            block = search.substr(0, search.indexOf(RegExp.$1));
            search = search.substring(block.length + RegExp.$1.length);
            var oScript = document.createElement('script');
            oScript.text = block;
            document.getElementsByTagName("head").item(0).appendChild(oScript);
        }
        document.getElementById(div).innerHTML=content;
    }   
    xhrRequest.send();
}

function _format_title(str) 
{
    return str.replace(/^Blog Post\:\s/, '');
}
function _format_name(str) 
{
    return str;
}
function _format_firstP(str) 
{
    var contents;
    try {
        contents = (str) ? $('<div></div>').html(str).text().replace(/<[\/]{0,1}([A-Z][A-Z0-9]*)\b[^>]*>/ig, '') : "";
    } catch (e) {
        contents = (str) ? str.replace(/<[\/]{0,1}([A-Z][A-Z0-9]*)\b[^>]*>/ig, '') : "";
    }
    var words = contents.split(' '),
    output = [],
    i = 0,
    numwords = words.length,
    length = 0;
    if (numwords > 0) {
        while ((length < 100) && (i < numwords)) {
            output.push(words[i]);
            length += words[i].length;
            i++;
        }
        if (i < numwords)
            output.push("...");
    }
    return output.join(' ');
}
function _short_Date(str) 
{
    return (str && str.length > 0 && str.indexOf('T') > -1) ? str.split('T')[0] : str;
}
function _format_linkid(str) 
{
    var validStr = str.replace(/[^0-9|^a-z| ]/ig, '').replace(/[ ]/ig, ' '),
    words = validStr.split(' '),
    len = words.length,
    i = 0,
    output = [];
    while (i < len && i < 8) {
      output.push(words[i]);
        i++;
    }
    return output.join('_');
}
function getBlogs(url)
{
    $('#blogs').RSSer({
        template : '<div><p><a name="&lid=en_us_somepage_[linkid]" href="[link]">[customTitle]</a>&nbsp;<em> [pubdate] </em></p> </div> <div class="widget-panel-bottom"></div>',
        rssURL : url,
        maxItems : 4,
        addedTemplateTokens : {
            "customTitle" : {
                "dataField" : "title",
                "processFn" : _format_title
            },
            "shortDesc" : {
                "dataField" : "description",
                "processFn" : _format_firstP
            },
            "linkid" : {
                "dataField" : "title",
                "processFn" : _format_linkid
            }
        },
        callback : function(){
            if (!$.trim($('#blogs').html())) {
                $("#blogheader").hide();
                var text = $("#blog a").text();
                $("#blog").html(text);
              }
        }
    });		  
}
function postSort(currentDiv){
    $(currentDiv).closest('table').closest('table.tblcart').each(function() {
            var $table = $(this);
            $('th.sortColumn', $table).each(function(column) {
                    var rows = $(currentDiv).closest('table').closest('table.tblcart').children('tbody').children('tr').filter(function() {
                            return ($(this).attr("class").toString().indexOf("tbltab2") == -1
                                    && $(this).attr("class").toString().indexOf("tbl1") == -1);
                    });
                    rows.sort(function(a, b) {
                            var keyA = $(a).children('td').eq(column).text().toUpperCase();
                            var keyB = $(b).children('td').eq(column).text().toUpperCase();
                            if(keyA = 'ARROW' &&  keyB != 'ARROW')return 1;
                            if(keyB = 'ARROW' &&  keyA != 'ARROW')return -1;
                            if (keyA < keyB) return -1;
                            if (keyA > keyB) return 1;
                            return 0;
                    });
                    $.each(rows, function(index, row) {
                            $table.children('tbody').append(row);
                    });
            });
    });
}
function regionTabAmericas(current) {
    setTimeout(function(){
        var $tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
        $tbody.children('tr.Asia').hide();
        $tbody.children('tr.Europe').hide();
        $tbody.children('tr.Surplus').hide();
        $tbody.children('tr.Japan').hide();
        $tbody.children('tr.Americas').show();
        $tbody.children('tr.Worldwide').show();
        $tbody.children('tr.Americas').addClass("alt");
        $tbody = $tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr');
        $tbody.children('td.Americas_region').addClass("activetd active");
        $tbody.children('td.Americas_region').addClass("activetd active");
        $tbody.children('td.Americas_region').addClass("selected_tab");
        $tbody.children('td.Asia_region').removeClass("activetd active");
        $tbody.children('td.Europe_region').removeClass("activetd active");
        $tbody.children('td.Surplus_region').removeClass("activetd active");
        $tbody.children('td.Asia_region').removeClass("selected_tab");
        $tbody.children('td.Europe_region').removeClass("selected_tab");
        $tbody.children('td.Surplus_region').removeClass("selected_tab");
        $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
        postSort(current);
            },10)
    }
function regionTabAsia(current) {
		setTimeout(function(){
        var $tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
        $tbody.children('tr.Americas').hide();
        $tbody.children('tr.Europe').hide();
        $tbody.children('tr.Japan').hide();
        $tbody.children('tr.Surplus').hide();
        $tbody.children('tr.Asia').show();
        $tbody.children('tr.Worldwide').show();
        $tbody.children('tr.Asia').addClass("alt");
        $tbody = $tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr');
        $tbody.children('td.Asia_region').addClass("activetd active");
        $tbody.children('td.Asia_region').addClass("selected_tab");
        $tbody.children('td.Americas_region').removeClass("activetd active");
        $tbody.children('td.Europe_region').removeClass("activetd active");
        $tbody.children('td.Surplus_region').removeClass("activetd active");
        $tbody.children('td.Americas_region').removeClass("selected_tab");
        $tbody.children('td.Europe_region').removeClass("selected_tab");
        $tbody.children('td.Surplus_region').removeClass("selected_tab");
        $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
        postSort(current);
        	},10)
}
function regionTabEurope(current){
	setTimeout(function(){
    var $tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
    $tbody.children('tr.Asia').hide();
    $tbody.children('tr.Americas').hide();
    $tbody.children('tr.Japan').hide();
    $tbody.children('tr.Surplus').hide();
    $tbody.children('tr.Europe').show();
    $tbody.children('tr.Worldwide').show();
    $tbody.children('tr.Europe').addClass("alt");
    $tbody = $tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr');
    $tbody.children('td.Europe_region').addClass("activetd active");
    $tbody.children('td.Europe_region').addClass("selected_tab");
    $tbody.children('td.Asia_region').removeClass("activetd active");
    $tbody.children('td.Americas_region').removeClass("activetd active");
    $tbody.children('td.Surplus_region').removeClass("activetd active");
    $tbody.children('td.Asia_region').removeClass("selected_tab");
    $tbody.children('td.Americas_region').removeClass("selected_tab");
    $tbody.children('td.Surplus_region').removeClass("selected_tab");
    $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
    postSort(current);
    	},10)
}
function regionTabJapan(current) {
	setTimeout(function(){
        var $tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
        $tbody.children('tr.Asia').hide();
        $tbody.children('tr.Americas').hide();
        $tbody.children('tr.Japan').show();
        $tbody.children('tr.Surplus').hide();
        $tbody.children('tr.Europe').hide();
        $tbody.children('tr.Worldwide').show();
        $tbody.children('tr.Japan').addClass("alt");
        $tbody = $tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr');
        $tbody.children('td.Japan_region').addClass("activetd active");
        $tbody.children('td.Japan_region').addClass("selected_tab");
        $tbody.children('td.Japan_region').css("display","");
        $tbody.children('td.Americas_region').css("display","none");
        $tbody.children('td.Asia_region').css("display","none");
        $tbody.children('td.Europe_region').css("display","none");
        $tbody.children('td.Surplus_region').css("display","none");
        $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","none");
        postSort(current);
        	},10)
}
function regionTabSurplus(current) {
	setTimeout(function(){
        var $tbody = $(current).closest('table').closest('table.tblcart').children('tbody');
        $tbody.children('tr.Asia').hide();
        $tbody.children('tr.Americas').hide();
        $tbody.children('tr.Japan').hide();
        $tbody.children('tr.Surplus').show();
        $tbody.children('tr.Europe').hide();
        $tbody.children('tr.Worldwide').hide();
        $tbody.children('tr.Surplus').addClass("alt");
        $tbody = $tbody.children('tr.tbltab2').children('td').children('table').children('tbody').children('tr');
        $tbody.children('td.Surplus_region').addClass("activetd active");
        $tbody.children('td.Surplus_region').addClass("selected_tab");
        $tbody.children('td.Asia_region').removeClass("activetd active");
        $tbody.children('td.Europe_region').removeClass("activetd active");
        $tbody.children('td.Americas_region').removeClass("activetd active");
        $tbody.children('td.Asia_region').removeClass("selected_tab");
        $tbody.children('td.Europe_region').removeClass("selected_tab");
        $tbody.children('td.Americas_region').removeClass("selected_tab");
        $(current).closest('table').closest('table.tblcart').closest('div').children(' p.disclaim').css("display","");
        postSort(current);
        	},10)
}
function showDistDetails(opn,oid,etype,qtype,targetId,subEvent,regionIdForDistributor) {	
    var localeId = "jp";
    var regionNameForDistributor ='Americas'; // Making America Default, Add below else for remaining Regions based on Distributor

    if(regionIdForDistributor == 29){ 
        regionNameForDistributor = 'Europe';
        }
    if(regionIdForDistributor == 34 || regionIdForDistributor == 35){ 
        regionNameForDistributor = 'Asia';
        }
     //Modified for PERK 946
        var p = $("#"+oid+"_"+qtype);
        var position = p.offset();
        $('#partsDist_'+oid).css('top', (position.top - 50));
        $('#partsDist_'+oid).css('position', "absolute");
        $('#errDialog').css('top', (position.top + 100));
        reqUrl = '/foldercomponents/jp/docs/product/getdistributordetails.tsp?action=display&elementId='+opn+"&elementType="+etype;
        $('#partsDist_'+oid).show();
        $('#overDist_'+oid).show();
                $.ajax({
                       url: reqUrl,
                       context: document.body,
                       timeout: 75000,
                       cache:false,
                       success: function(data){
                              $('#'+targetId).html(data);
                       },
                       error:function (xhr, ajaxOptions, thrownError){

                             }
                     }).done(function() {
                             if(regionNameForDistributor == "Americas"){
                             regionTabAmericas($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').children('a'));
                         }
                         else if(regionNameForDistributor == "Asia"){
                             regionTabAsia($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').children('a'));
                         }
                         else if(regionNameForDistributor == "Europe"){
                             regionTabEurope($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Europe_region').children('a'));
                         }
                         else if(regionNameForDistributor == "Japan" && localeId == 'jp'){
                             regionTabJapan($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').children('a'));
                         }
                         else {
                             if(localeId=='en'){
                                             regionTabAmericas($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Americas_region').children('a'));
                                     }
                                     if(localeId=='cn'){
                                             regionTabAsia($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Asia_region').children('a'));
                                     }
                                     if(localeId=='jp'){
                                             regionTabJapan($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').children('a'));
                                     }
                         }

                        $(".formtipbox").hide();

                        $(".formtip").toggle(function(){
                                $(this).addClass("active");
                                }, function () {
                                $(this).removeClass("active");
                        });
                        $(".formtip").mouseover(function(){
                                $(this).next(".formtipbox").fadeIn("slow,");
                        });
                        $(".formtip").mouseout(function(){
                                $(this).next(".formtipbox").fadeOut("slow,");
                        });
                        $("#errok").click(function(){
                                $('#errDialog').hide();
                                $('.ui-widget-overlay').hide();
                        });
                       $(document).keydown(function(e){
                           var code = e.keyCode ? e.keyCode : e.which;
                           if(code == 27){
                             $('#errDialog').hide();
                                     $('.ui-widget-overlay').hide();
                           }
                        });
                             postSort($("#partsDist_"+oid).find("table.tblcart").children('tbody').children('tr.tbltab2').children('td').children('table').children('tbody').children('tr').children('td.Japan_region').children('a'));
                       });

}
function fnOrderOnline(url)
{
    window.open(url,'_blank');
}
function updateCartRibbon(){

    $.ajax({
              type: 'GET',		       
              url: '',
              dataType: 'jsonp',
              jsonp: 'jsonp_callback',
              success: function (data) {	
                   // added for cart ribbon scenario
                      var r = "";
                      var v = "";
                      var t = "";
                  if (data.length == 0) {
                       $("div.border").show();
                       $("#columnwithdata").hide();
                       $("#middle1").hide();
                       $("#middle2").hide();
                       $("#columnlast").hide();
                   } else {
                       $("div.border").hide();
                       $("#emptycartdiv").hide();
                       var lang = '/';
                       var websitevalue = "jp";
                       if(websitevalue != "en"){
                          lang = '/'+websitevalue+'/';
                        }	
                       $.each(data, function(z, A) {
                           if (z < 3) {
                               if (this.ProductType == "IC") {
                                   r += '<li><a target="_blank" href="/product'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               } else {
                                   r += '<li><a target="_blank" href="/tool'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               }
                           }
                           if (z > 2 && z < 6) {
                               if (this.ProductType == "IC") {
                                   v += '<li><a target="_blank" href="/product'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               } else {
                                   v += '<li><a target="_blank" href="/tool'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               }
                           }
                           if (z > 5 && z < 9) {
                               if (this.ProductType == "IC") {
                                   t += '<li><a target="_blank" href="/product'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               } else {
                                   t += '<li><a target="_blank" href="/tool'+lang + this.Sku + '">' + this.Sku + '</a><span class="shoppingCart-price">' + this.UnitPrice.substring(0, this.UnitPrice.indexOf(".")) + "</span></li>";
                               }
                           }
                           if (z == 10) {
                               return false;
                           }
                       });
                       $("#cartData2").html(r);
                       $("#middleCartData1").html(v);
                       $("#middleCartData2").html(t);
                       $("#columnwithdata").show();
                       $("#middle1").show();
                       $("#middle2").show();
                       $("#columnlast").show();
                   }
                   $("#cartCount2").text(data.length);
                   $("#cartCount3").text(data.length);
                   r = "";
                   v = "";
                   t = "";
                   // added for cart ribbon scenario - ends						
              },
              error: function (request, error) {
                  /* NOSONAR */ alert("Error while adding the part to the cart "+error);
              }
          });  
}
function fnAddToeStoreCart(opid,opn,gpn,targetId,subEvent,ordername,unitprice,linkID) 
{
	var crossSellAvailable = false;
		//added for metrics tracking
		setTimeout(function() {
            if (typeof tiStoreCheckOut === 'function') {
                tiStoreCheckOut(linkID,tiPageName, tiContentGroup, opn, 'buy - paid tool', crossSellAvailable);
            }
				}, 2000);
        // call the http://uat.estore-tisep.harte-hanks.com/AddToCart_TI.aspx?p=DRV8829EVM
        addToCartStoreUrl = addToCartStoreUrl ? addToCartStoreUrl : "";
		var url = addToCartStoreUrl ? addToCartStoreUrl+"?p="+opn : "";
		var eStoreWindow = window.open(url, "estoreWin");		             
        eStoreWindow.focus();
        setTimeout(function() {
			updateCartRibbon();
		}, 2000);
}
function addToCart(opn,etype,gpn,oid,targetId,ev) 
{
	$("td[id^='buy']").closest('tr').remove();
	$("svg[id^='chrUp_'] use").attr('xlink:href', '/etc/designs/ti/images/icons/svg/ti_icons-objects.svg#chevron-down');
	if ($('.cartModal').length > 0) {
		$(".cartModal").hide();
	}		
   var p = $("#addCart_"+oid+"_reg");
   var position = p.offset();
   $('#addCart_'+oid).css('top', (position.top + 60));
   $('#addCart_'+oid).css('left', (position.left + 100));
   $('#addCart_'+oid).css('position', "absolute");
   var addtoCartUrl = "https://" + document.domain + '/foldercomponents/jp/docs/product/addtocart.tsp?elementId='+opn+"&elementType="+etype+"&gpn="+gpn+"&opnId="+oid;
 	$('#addCart_'+oid).show();
   $.ajax({
		  url: addtoCartUrl,
		  context: document.body,
		  timeout: 75000,
		  cache:false,
		  async: false,
		  xhrFields: {
              withCredentials: true
           },
           crossDomain: true,
		  success: function(data){
			  $('#'+targetId).html(data);
			    var cart_data ={ distributor_name: "ti store", ti_opn: opn, ti_gpn: gpn, part_type: "tool" };
			  _tiAnalyticsTrack("ti store add", cart_data);
			  $( document ).trigger("cartModalOpen");
		  },
		  error:function (xhr, ajaxOptions, thrownError){

  		  }
	   }).done(function() {});	   
	   ev.stopImmediatePropagation();
}

function closeWindow(){
	$('#mask').hide();		
	$('#crosssellcart').hide();
}
function toolAlert(urlString,orderablePartName,orderablePartNumber){
    $.ajax({
      type: 'GET',
        contentType: "application/json; charset=utf-8",					
        url: urlString,
        dataType: 'jsonp',
        success: function (response) {
            if(response.mode!=null){
                if(response.mode == 'productalertsexist'){
                    htmlString  ='<div class="modalAlert-bg"></div>';
                    htmlString +='<div class="modalAlert">';
                    htmlString +='<div class="modalWindow">';
                    htmlString +='<a class="close" onclick="closeAlert();"></a>';
                    htmlString +='<h2>アラートを受け取る</h2>';
                    htmlString +='<p>既に のアラートが設定されています<strong>'+response.itemNumber+': ' +response.itemName+'.</strong></p>';      
                    htmlString +='<a class="button btnA lrg" onclick="closeAlert();">閉じる</a><a class="button btnA lrg" href="/myti/docs/maintainalert.tsp?sectionId=710&tabId=20357">アラートの管理</a>';
                    htmlString +='</div>';
                    htmlString +='</div>';
                            $("#targetIdNew").html(htmlString);
                            $("#targetIdNew").show();
                }
                if(response.mode == 'addtoolalerts'){						
                    htmlString='<div class="modalAlert-bg"></div>';
                    htmlString+='<div class="modalAlert">';
                    htmlString+='<div class="modalWindow">';
                    htmlString+='<a class="close" onclick="closeAlert();"></a>';
                    htmlString+='<h2>アラートを受け取る</h2>';
                    htmlString+='<h3>'+response.itemNumber+': '+response.itemName+'</h3>';
                    htmlString+='<p>バージョン更新や大きな変更があった場合は、このツールのアラートが送信されます。</p>';      
                    htmlString+='<hr>';
                    htmlString+='<a class="button btnA lrg" onclick="addtoolalert(\''+response.itemNumber+'\'';
                    htmlString+= ','+'\''+response.itemParent;
                    htmlString +='\',';
                    htmlString +='\''+orderablePartName+'\');">アラートを追加する</a>';
                    htmlString+='<div class="userInfo">';
                    htmlString+='<p>メール送信先： '+response.emailId;
                    if(response.accessLevel!=null && response.accessLevel==0){
                        htmlString+=' | <a href="/myti/docs/loginpwd.tsp?sectionId=710&tabId=20365>編集</a>';
                    }
                    htmlString+='<br>未 ' +response.firstName+' ? ';
                    htmlString+='<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https%3A%2F%2Fwww.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+response.itemNumber+'%26productType%3DTool">別のユーザーとしてログインします。</a></p>';
                    htmlString+='</div></div></div>';
                    
                    //alert("add tool alert"+htmlString);
                    $("#targetIdNew").html(htmlString);
                    $("#targetIdNew").show();
                }
            }
            
        },
        error: function (request, ajaxOptions, thrownError) {
            htmlString='<div class="modalAlert-bg"></div>';
            htmlString +='<div class="modalAlert">';
            htmlString +='<div class="modalWindow">';
            htmlString +='<a class="close" onclick="closeAlert();"></a>';
            htmlString +='<h2>アラートを受け取る</h2>';
            htmlString +='<h3>'+orderablePartNumber+': '+orderablePartName+'</h3>';
            htmlString +='<p>バージョン更新や大きな変更があった場合は、このツールのアラートが送信されます。</p>';      
            htmlString +='<hr>';
            htmlString +='<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https%3A%2F%2Fwww.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+orderablePartNumber+'%26productType%3DTool" class="button btnA lrg">すぐにログインまたは登録する</a>';
            htmlString +=' <div class="userInfo">';
            htmlString +='<p>アラートを受け取るには、my.TI アカウントの登録が必要です。</p>';
            htmlString +='</div></div></div>';
            //alert("tool not logged in"+htmlString);
            $("#targetIdNew").html(htmlString);
            $("#targetIdNew").show();				
        }
    });	
}	
function addtoolalert(partNumber,itemParent,orderablePartName){
	$.ajax({
		url: '/myti/docs/productalert.tsp?isFolder=true&actionPerformed=addAlert&folderId=2&itemNumber='+partNumber+'&itemParent='+itemParent,
		//data: {orderNumber:orderNum, orderType:orderType},
		context: document.body,
		type: "GET",	
		contentType: "application/json; charset=utf-8",		
		dataType: "jsonp",
		success: function(response) {
			    htmlString='<div class="modalAlert-bg"></div>';
				htmlString+='<div class="modalAlert">';
				htmlString+='<div class="modalWindow">';
				htmlString+='<a class="close" onclick="closeAlert();"></a>';
	            htmlString+='<h2>アラートの確認</h2>';
	            htmlString+='<p>のアラート '+response.itemNumber+': ' +response.itemName+ ' に送信される '+response.emailId+'.</p>';      
	            htmlString+='<a class="button btnA lrg" onclick="closeAlert();">閉じる</a><a class="button btnA lrg" href="/myti/docs/maintainalert.tsp?sectionId=710&tabId=20357">アラートの管理</a>';
				htmlString+='</div></div>';
								$("#targetIdNew").html(htmlString);
								$("#targetIdNew").show();
								
		},
		error: function(request, textStatus, errorThrown) {					
					htmlString='<div class="modalAlert-bg"></div>';
					htmlString +='<div class="modalAlert">';
					htmlString +='<div class="modalWindow">';
					htmlString +='<a class="close" onclick="closeAlert();"></a>';
					htmlString +='<h2>アラートを受け取る</h2>';
					htmlString +='<h3>'+partNumber+': '+orderablePartName+'</h3>';
					htmlString +='<p>バージョン更新や大きな変更があった場合は、このツールのアラートが送信されます。</p>';      
					htmlString +='<hr>';
					htmlString +='<a href="https://ti-pass.ext.ti.com/cgi-bin/login/logout.pl?lt=myti&dpi=1&drm=1&returnto=https%3A%2F%2Fwww.ti.com%2Fmyti%2Fdocs%2Fhomepage.tsp%3FsectionId%3D710%26partNumber%3D'+partNumber+'%26productType%3DTool" class="button btnA lrg">すぐにログインまたは登録する</a>';
					htmlString +=' <div class="userInfo">';
					htmlString +='<p>アラートを受け取るには、my.TI アカウントの登録が必要です。</p>';
					htmlString +='</div></div></div>';
					//alert("tool not logged in"+htmlString);
					$("#targetIdNew").html(htmlString);
					$("#targetIdNew").show();
		}
		
	});	
}

function closeAlert(){
    $("#targetIdNew").hide(); 
  }
$(document).ready(function() {
    $(".showMore").show();
    $(".showLess").hide();
    $(".showMore").children("a").click(function() {
        $(this).parent().parent().children(".cnt").removeClass("less");
        $(this).parent().parent().children(".showMore").hide();
        $(this).parent().parent().children(".showLess").show();
        $(this).parent().parent().children(".showMore").prev().slideDown();
        return false
    });
    $(".showLess").children("a").click(function() {
        $(this).parent().parent().children(".cnt").addClass("less");
        $(this).parent().parent().children(".showMore").show();
        $(this).parent().parent().children(".showLess").hide();
        return false
    });
    $(document).bind("keydown", "Ctrl+f", function() {
        if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            $(".showMore").children("a").each(function() {
                $(this).parent().parent().children(".cnt").removeClass("less");
                $(this).parent().parent().children(".showMore").hide();
                $(this).parent().parent().children(".showLess").show();
                $(this).parent().parent().children(".showMore").prev().slideDown()
            })
        }
    });
    if ($("#tblDevTool tr").length > 2) {
        $("#tblDevTool").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblDesKit tr").length > 2) {
        $("#tblDesKit").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblRefDesigns tr").length > 2) {
        $("#tblRefDesigns").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblDesNetwork tr").length > 2) {
        $("#tblDesNetwork").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    if ($("#tblTiDevice tr").length > 2) {
        $("#tblTiDevice").tablesorter({
            headers: {
                3: {
                    sorter: false
                },
                4: {
                    sorter: false
                }
            }
        })
    }
    if ($("#tblSoftware tr").length > 2) {
        $("#tblSoftware").tablesorter({
            sortList: [
                [0, 0]
            ]
        })
    }
    $(".symfoot tr").each(function() {
        if ($(this).attr("class") != "symtable") {
            var b = $(this).find("td:first");
            var d = $(this).next().find("td:first");
            if ($(d).text() != "" && $(d).text() != " ") {
                $(b).css("border-bottom", "1px solid #E0E0E0");
                $(d).css("border-top", "1px solid #E0E0E0")
            }
        }
    });
    //moving cookie name string to var to use as region checker
    var distCookie = "DISTRIBUTOR_JP";
    var a = readDistCookie(distCookie);
    if (a != "" && a != '""' && a != null && typeof a !== "undefined") {
        var h = a.split("_");
        var e = h[0];
        if (e == 10) {
            $(".buy_digikey").html("Digi-key から購入");
            $(".dist_button").val("Digi-key から購入")
        } else if (e == 2) {
            $(".buy_digikey").html("Avnet から購入");
            $(".dist_button").val("Avnet から購入")
        } else if (e == 26) {
            $(".buy_digikey").html("Mouser から購入");
            $(".dist_button").val("Mouser から購入")
        //next two only available for EN
        } else if (e == 1 && distCookie === "DISTRIBUTOR_EN") {
            $(".buy_digikey").html("Buy from Arrow");
            $(".dist_button").val("Buy from Arrow")
        } else if (e == 29 && distCookie === "DISTRIBUTOR_EN") {
            $(".buy_digikey").html("Buy from Farnell element14");
            $(".dist_button").val("Buy from Farnell element14")
        } else if (e == 11) {
            $(".buy_digikey").html("Buy from Newark element14");
            $(".dist_button").val("Buy from Newark element14")
        } else if (e == 34) {
            $(".buy_digikey").html("Buy from element14 Asia");
            $(".dist_button").val("Buy from element14 Asia")
        } else if (e == 35) {
            $(".buy_digikey").html("Buy from e络盟 element14");
            $(".dist_button").val("Buy from e络盟 element14")
        }
    } else {
        $(".buy_digikey").html("販売特約店より購入");
        $(".dist_button").val("購入")
    }
    $(".contactid").each(function() {
        var $this = $(this);
        var g = readDistCookie(distCookie);
        if (g != "" && g != '""' && g != null && typeof g !== "undefined") {
            var d = g.split("_");
            var l = d[2];
            var distId= d[0]; 
            // Get the GPN from current Location :: http://www.ti.com/tool/CCSTUDIO/**/*
            var f = window.location.href.split("/")[4];
            // Setting Default value to Digi-key (dist id =10)
            $this.html('<span style="FONT-SIZE: 14px; FONT-WEIGHT: bold">Pricing may vary.</span><br><br><br><br><br><a href="https://www.digikey.com/product-search/' + l + "?Keywords=" + f + '">View All Stock</a>');
            var j = 0;
            if (l == 'en') {
                j = -1
            } else if (l == 'cn') {
                j = -7
            } else if (l == 'jp') {
                j = -10
            }
            var $hrefLink = $(this).children('a:first'); 
            if (distId == 10) {
            	$hrefLink.attr("href", "https://www.digikey.com/product-search/"+ l +"?KeyWords=" + f);
            } else if (distId == 26) {
            	$hrefLink.attr("href", "https://www.mouser.com/Search/Refine.aspx?KeyWord=" + f);
            } else if (distId == 2) {
            	$hrefLink.attr("href","https://www.avnet.com/shop/SearchDisplay?searchTerm="+ f +"&storeId=715839035&catalogId=10001&langId=" + j + "&&pageNumber=1#facet=mfName_ntk_cs%3A%22Texas+Instruments%22");
            } else if (distId == 29) {
            	$hrefLink.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + f + "+texas+instruments&action=list&COM=TI");
            } else if (distId == 1) {
            	$hrefLink.attr("href", "https://www.arrow.com/" + l + "/products/search?q=" + f + "&filters=Manufacturer_name:Texas+Instruments");
            } else if (distId == 11) {
            	$hrefLink.attr("href", "https://www.newark.com/search?st=" + f + "&mf=100066");
            } else if (distId == 34) {
            	$hrefLink.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + f + "+texas+instruments&action=list&COM=TI");
            } else if (distId == 35) {
            	$hrefLink.attr("href", "https://www.element14.com/community/view-product.jspa?url=" + f + "+texas+instruments&action=list&COM=TI");
            } else {
            	$this.html("Not Available");
            }
            
        } else {
        		$this.html("Not Available"); 
        }
    });
    $(".view_all_options").click(function() {
        $("#en_dist_cookie_form1").submit();
        $("#cn_dist_cookie_form1").submit();
        $("#jp_dist_cookie_form1").submit();
        setTimeout(function() {
            location.reload(true)
        }, 2000)
    });
    $(document).click(function(d) {
        var b = $(d.target);
        if (b.attr("id") != "schematicsimulation") {
            if (b.closest("div").attr("class") == "close") {
                $("#downloadMultiple").hide()
            } else {
                if (b.attr("id") == "downloadMultiple" || b.closest("div").attr("id") == "downloadMultiple" || b.closest("div").parent("div").attr("id") == "downloadMultiple") {
                    $("#downloadMultiple").show()
                } else {
                    $("#downloadMultiple").hide()
                }
            }
        }
        if (b.attr("id") != "testsimulation") {
            if (b.closest("div").attr("class") == "close") {
                $("#downloadMultiple1").hide()
            } else {
                if (b.attr("id") == "downloadMultiple1" || b.closest("div").attr("id") == "downloadMultiple1" || b.closest("div").parent("div").attr("id") == "downloadMultiple1") {
                    $("#downloadMultiple1").show()
                } else {
                    $("#downloadMultiple1").hide()
                }
            }
        }
        if (b.attr("id") != "cadsimulation") {
            if (b.closest("div").attr("class") == "close") {
                $("#downloadMultiple2").hide()
            } else {
                if (b.attr("id") == "downloadMultiple2" || b.closest("div").attr("id") == "downloadMultiple2" || b.closest("div").parent("div").attr("id") == "downloadMultiple2") {
                    $("#downloadMultiple2").show()
                } else {
                    $("#downloadMultiple2").hide()
                }
            }
        }
        if (b.attr("id") != "bom1") {
            if (b.closest("div").attr("class") == "close") {
                $("#downloadMultiple3").hide()
            } else {
                if (b.attr("id") == "downloadMultiple3" || b.closest("div").attr("id") == "downloadMultiple3" || b.closest("div").parent("div").attr("id") == "downloadMultiple3") {
                    $("#downloadMultiple3").show()
                } else {
                    $("#downloadMultiple3").hide()
                }
            }
        }
    });

    if(document.getElementById('images') != null)
    {
        var count = document.getElementById('images').value;
        for(var i=1; i<= count; i++) 
        {
		    var image = $('#image_'+i).attr("original");
		    var sub = image.lastIndexOf("/");
		    var substr = image.substring(sub+1,image.length);
		    var substr1 = substr.lastIndexOf(".");
		    var extn = substr.substring(substr1,image.length);
		    var substr2 = substr.substring(0,substr1);
		    substr2 = image.substring(0,sub)+"/"+"med_"+substr2+extn;
		    $('#image_'+i).attr("href",substr2);
        }
        	var gallery = $('#gallery').galleriffic('#navigation',{
		delay:                2000,
		numThumbs:            12,
		imageContainerSel:    '#slideshow',
		controlsContainerSel: '#controls',
		titleContainerSel:    '#image-title',
		downloadLinkSel:      '#download-link',
		fixedNavigation:	   true,
		galleryKeyboardNav:	   true,
		autoPlay:			   false
	});
    }

});